import { viewTechDocRouteRef } from '@agilelab/plugin-wb-builder-catalog';
import { BlueprintEntity } from '@agilelab/plugin-wb-builder-common';
import { DEFAULT_NAMESPACE } from '@mainstage/catalog-model';
import { useApi, useRouteRef } from '@mainstage/core-plugin-api';
import {
  ScmIntegrationIcon,
  scmIntegrationsApiRef,
} from '@mainstage/integration-react';

import { getEntitySourceLocation } from '@mainstage/plugin-catalog-react';
import { Box, IconButton } from '@material-ui/core';
import { WbTooltip, WbUnstyledLink } from '@agilelab/plugin-wb-platform';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { FC } from 'react';
import { useTechDocsDrawer } from '../../hooks/useTechDocsDrawer';

interface Props {
  blueprint: BlueprintEntity;
}

export const BlueprintCardActions: FC<Props> = ({ blueprint }) => {
  const scmIntegrationsApi = useApi(scmIntegrationsApiRef);
  const sourceLocation = getEntitySourceLocation(blueprint, scmIntegrationsApi);
  const viewTechDoc = useRouteRef(viewTechDocRouteRef);
  const viewTechDocsAnnotation =
    blueprint.metadata.annotations?.['backstage.io/techdocs-ref'];
  const viewTechDocsLink =
    !!viewTechDocsAnnotation &&
    !!viewTechDoc &&
    viewTechDoc({
      namespace: blueprint.metadata.namespace ?? DEFAULT_NAMESPACE,
      kind: blueprint.kind,
      name: blueprint.metadata.name,
    });
  const { openDocs, TechDocsDrawer } = useTechDocsDrawer();
  return (
    <>
      <Box style={{ display: 'flex', alignItems: 'center' }}>
        {sourceLocation && (
          <WbTooltip title="Code">
            <IconButton
              component={WbUnstyledLink}
              to={sourceLocation.locationTargetUrl ?? '#'}
              target="_blank"
              rel="noopener"
              color="secondary"
              size="small"
              aria-label="code"
              disabled={!sourceLocation.locationTargetUrl}
            >
              <ScmIntegrationIcon type={sourceLocation.integrationType} />
            </IconButton>
          </WbTooltip>
        )}

        {viewTechDocsLink && (
          <WbTooltip title="Documentation">
            <IconButton
              color="secondary"
              onClick={() => openDocs(blueprint)}
              size="small"
              aria-label="documentation"
            >
              <InfoOutlinedIcon />
            </IconButton>
          </WbTooltip>
        )}
      </Box>
      {TechDocsDrawer}
    </>
  );
};
